import { BigNumber } from 'ethers'

export const REWARD_WITHDRAWAL_DELAY_SECONDS = 24 * 60 * 60
export const MAX_EARLY_WITHDRAWAL_AUDIT_USERS = 100

const toBigNumber = (value) => {
    if (BigNumber.isBigNumber(value)) return value
    if (value === null || value === undefined || value === '') return BigNumber.from(0)
    return BigNumber.from(String(value))
}

export function calculateMaximumStakeAmount({ balance, poolLimitPerUser, userStakedAmount }) {
    const walletBalance = toBigNumber(balance)
    const limit = toBigNumber(poolLimitPerUser)
    if (limit.lte(0)) return walletBalance

    const staked = toBigNumber(userStakedAmount)
    if (staked.gte(limit)) return BigNumber.from(0)

    const remainingAllowance = limit.sub(staked)
    return walletBalance.lte(remainingAllowance) ? walletBalance : remainingAllowance
}

export function getRewardClaimAudit({ userCount, users = [] }) {
    const total = Math.max(0, Number(userCount) || 0)
    if (total > MAX_EARLY_WITHDRAWAL_AUDIT_USERS) {
        return {
            status: 'too-many-users',
            checkedUserCount: 0,
            unclaimedUserCount: null,
            canWithdrawEarly: false,
        }
    }
    if (users.length !== total) {
        throw new Error(`Expected ${total} staking users, received ${users.length}`)
    }

    const unclaimedUserCount = users.filter((user) => (
        toBigNumber(user.rewardAmount).gt(toBigNumber(user.hasBeenClaimdReward))
    )).length
    return {
        status: unclaimedUserCount === 0 ? 'all-claimed' : 'unclaimed-rewards',
        checkedUserCount: total,
        unclaimedUserCount,
        canWithdrawEarly: unclaimedUserCount === 0,
    }
}

export function getRewardWithdrawalProtection({ endTimeUnix, nowUnix, canWithdrawEarly = false }) {
    const availableAtUnix = Math.max(0, Number(endTimeUnix) || 0) + REWARD_WITHDRAWAL_DELAY_SECONDS
    const remainingSeconds = Math.max(0, availableAtUnix - (Number(nowUnix) || 0))
    return {
        availableAtUnix,
        remainingSeconds,
        isAvailable: Boolean(endTimeUnix) && (remainingSeconds === 0 || canWithdrawEarly),
    }
}

export function formatProtectionCountdown(totalSeconds) {
    const seconds = Math.max(0, Math.floor(Number(totalSeconds) || 0))
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const remainingSeconds = seconds % 60
    return [hours, minutes, remainingSeconds].map((value) => String(value).padStart(2, '0')).join(':')
}
